import { SignInService } from '../services/SignInService';

import { useService } from '../../../Hooks/useService';

export function useSignInService() {
    return useService(SignInService);
}
